import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type BaseMembership } from '../domain/member';

export interface PendingMemberSlice extends BaseMembership {
    external?: boolean;
    firstName?: string;
    lastName?: string;
    email?: string;
    ref?: string;
}


const initialState: PendingMemberSlice = {
    email: '',
    expiration: '',
    external: false,
    firstName: '',
    lastName: '',
    start: '',
};


const pendingMemberSlice = createSlice({
    initialState,
    name: 'temp-member',
    reducers: {

        // Clear the pending group user
        clearPendingMember: () => {
            return initialState;
        },

        // Set the pending group user
        setPendingMember: (state, action: PayloadAction<PendingMemberSlice>) => {
            // Ensure that the payload is serializable
            state = action.payload;
            return state;
        },

        // Update the pending group user properties
        updatePendingMemberProps: (state, action: PayloadAction<PendingMemberSlice>) =>
            // Make sure to return a new state object instead of mutating the existing one
            ({ ...state, ...action.payload })
        ,
    },
});

// Export the action creators and reducer
export const { setPendingMember, clearPendingMember, updatePendingMemberProps } = pendingMemberSlice.actions;
export default pendingMemberSlice.reducer;
